module.exports = __webpack_public_path__ + "img/Farewell-Valeria-Lutfullina.ac985992.jpg";